import request from '@/utils/request'

/**
 * 会员相关接口定义
 */
const MemberAPI = {
  /**
   * 获取会员套餐类型列表
   * @returns {Promise} 返回会员套餐列表
   */
  getMemberTypes() {
    return request({
      url: '/public/memberTypes',
      method: 'get'
    })
  }
}

export default MemberAPI
